import { createClient } from '@wolffun/wallet-adapter';
import { THETA_CHAIN_ID_NUMBER, THETA_CHAIN_PROVIDER_URL } from '../../constants';
import { InjectedConnector } from '@wolffun/wallet-adapter/src/connectors/injected';
import { MetaMaskConnector } from '@wolffun/wallet-adapter/src/connectors/metaMask';
import { WalletConnectConnector } from '@wolffun/wallet-adapter/src/connectors/walletConnect';
import { SequenceConnector } from '@wolffun/wallet-adapter/src/connectors/sequence';
import { CoinbaseConnector } from '@wolffun/wallet-adapter/src/connectors/coinbase';
import { ThetanWalletConnector } from '@wolffun/wallet-adapter/src/connectors/thetanWallet';
import { EipError, WalletProvider } from '../types';
import { getPreferredWalletProviderName } from './session';
const client = createClient();
const walletConnectOps = {
  rpc: {
    [THETA_CHAIN_ID_NUMBER]: THETA_CHAIN_PROVIDER_URL
  }
};
export const getConnector = (() => {
  const cache = {
    [WalletProvider.COINBASE]: new CoinbaseConnector(),
    [WalletProvider.METAMASK]: new MetaMaskConnector(),
    [WalletProvider.WALLET_CONNECT]: new WalletConnectConnector({
      options: walletConnectOps
    }),
    [WalletProvider.SEQUENCE]: new SequenceConnector({
      options: {
        connect: {
          networkId: THETA_CHAIN_ID_NUMBER,
          app: 'Thetan Arena marketplace'
        }
      }
    }),
    [WalletProvider.THETAN_WALLET]: new ThetanWalletConnector(),
    default: new InjectedConnector()
  };
  return provider => {
    let _provider = provider;

    if (!provider) {
      const storedProvider = getPreferredWalletProviderName();

      if (!storedProvider) {
        return cache.default;
      }

      _provider = storedProvider;
    }

    switch (_provider) {
      case WalletProvider.COINBASE:
        return cache[WalletProvider.COINBASE];

      case WalletProvider.METAMASK:
        return cache[WalletProvider.METAMASK];

      case WalletProvider.WALLET_CONNECT:
        return cache[WalletProvider.WALLET_CONNECT];

      case WalletProvider.SEQUENCE:
        return cache[WalletProvider.SEQUENCE];

      case WalletProvider.THETAN_WALLET:
        return cache[WalletProvider.THETAN_WALLET];

      default:
        return cache.default;
    }
  };
})();
export const tryConnectWallet = async provider => {
  try {
    if (walletClient.isConnected && provider !== undefined) {
      await destroyWalletClient();
    }

    if (!walletClient.isConnected) {
      await walletClient.connect({
        chainId: THETA_CHAIN_ID_NUMBER,
        connector: getConnector(provider)
      });
    }

    return {
      error: EipError.NO_ERROR
    };
  } catch (e) {
    return {
      error: EipError.UNNKOWN
    };
  }
};
export const destroyWalletClient = async () => {
  await client.disconnect();
};
export const walletClient = client;
export const getCurrentConnector = () => {
  if (!walletClient.connector) {
    return getConnector();
  }

  return walletClient.connector;
};